import { IEnvironment, environmentDev } from '@vivela/xplat/environment';
import { deepMerge } from '@vivela/xplat/utils';

export const environment: IEnvironment = deepMerge(environmentDev, {
  // app level customizations here...
} as IEnvironment);
